import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M6.52,16.73a.25.25,0,0,0-.24-.23H2.75a1,1,0,0,0,0,2H6.81A.26.26,0,0,0,7,18.37a.27.27,0,0,0,0-.26A3.08,3.08,0,0,1,6.52,16.73Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M12.34,9.5h5.79a.24.24,0,0,0,.24-.22l.49-3.67a.24.24,0,0,1,.16-.2,1.51,1.51,0,1,0-1.48-.26.25.25,0,0,1,.06.31,3.43,3.43,0,0,1-3.1,2C12,7.5,11,4.66,10.67,3a.25.25,0,0,1,.12-.26A1.53,1.53,0,0,0,11.5,1.5,1.5,1.5,0,1,0,9.21,2.78.25.25,0,0,1,9.33,3C9,4.66,8,7.5,5.5,7.5a3.42,3.42,0,0,1-3.11-2,.24.24,0,0,1,.06-.3,1.5,1.5,0,0,0-1-2.66A1.5,1.5,0,0,0,1,5.41a.24.24,0,0,1,.16.2l1.11,8.46a.51.51,0,0,0,.5.43H7.08a.25.25,0,0,0,.2-.1l2.63-3.66A3,3,0,0,1,12.34,9.5Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M23.71,15.57l-2.85-4a1.49,1.49,0,0,0-1.2-.6H12.34a1.49,1.49,0,0,0-1.21.62L8.3,15.55a1.51,1.51,0,0,0,.17,2l6.49,6A1.48,1.48,0,0,0,16,24a1.51,1.51,0,0,0,1-.41l6.53-6.07A1.5,1.5,0,0,0,23.71,15.57Zm-3.54,2.36-4,3.73a.25.25,0,0,1-.34,0l-4-3.73A.25.25,0,0,1,12,17.5h8a.25.25,0,0,1,.24.16A.25.25,0,0,1,20.17,17.93Zm.77-2.57a.25.25,0,0,1-.23.14H11.29a.25.25,0,0,1-.23-.14.27.27,0,0,1,0-.26l1.44-2a.26.26,0,0,1,.2-.1h6.56a.26.26,0,0,1,.2.1l1.44,2A.27.27,0,0,1,20.94,15.36Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }